export default {
    path: "/login",
    name:"login",
    component: () => import('@/view/Login'),
    meta:{
        name:"登录",
        assess:false
    }
}


// WEBPACK FOOTER //
// ./src/router/modules/Login.js